const ImageWithContentRight = ({
    imageUrl,
    title,
    alt,
    content,
  }: {
    imageUrl: string;
    title: string;
  /** Describes the image for screen readers and search engines. Defaults to `title`. */
  alt?: string;
    content: string;
  }) => {
    return (
      <div
        style={{
          paddingLeft: "clamp(.2rem, 6vw, 8rem)",
          paddingRight: "clamp(.2rem, 6vw, 8rem)",
          paddingTop: "clamp(.2rem, 2vw, 6rem)",
          paddingBottom: "clamp(.2rem, 2vw, 4rem)",
        }}
        className="grid grid-cols-11 items-start mb-4"
      >
        <div className="col-span-11 lg:col-span-5 py-4">
          <p className="title-text-size text-custom-secolor animated-content">
            {title}
          </p>
          <div className="custom__divider pb-4">
          </div>
          <p className="text-md text-justify content-text-size tracking-normal break-normal leading-relaxed">
            {content}
          </p>
        </div>
        <div className="col-span-11 lg:col-start-7 lg:col-span-5 py-4 flex justify-center lg:justify-end">
          <figure>
            <img
              className="w-[clamp(300px,50vw,600px)] h-[clamp(200px,30vw,400px)] rounded-lg object-cover"
              src={imageUrl}
              alt={alt ?? title}
            />
          </figure>
        </div>
      </div>
    );
  };
  
  export default ImageWithContentRight;
  